import React, { useState } from "react";
import location from "../img/svg/icon-2.svg";
import ContactApi from "../api/Contact";
import PageTitle from "../api/PageTitle";

const Contact = () => {
  const [contactData] = useState(ContactApi);
  // const [formData, setFormData] = useState();

  return (
    <>
      <PageTitle name="Contact" link="Home" page="Contact" />

      <div className="contact-data">
        {contactData.map((curEle) => {
          return (
            <>
              <div className="contact-address">
                <img src={location} alt="" className="contact-icon" />
                <span className="contact-detail">
                  <h3 className="contact-h3">Our Address</h3>
                  <p className="contact-p1">
                    PSD Building, 2 AlBhar St. Loskia sripur, Jamukara
                  </p>
                </span>
              </div>
            </>
          );
        })}
      </div>
      <div className="contact-form">
        <h1 className="form-h1">Contact Form</h1>
        <form action="" className="contact-form">
          <span className="contact-span">
            <input type="text" placeholder="Enter your full name" required />
            <input
              required
              type="text"
              placeholder="Enter your email"
              className="contact-input-2"
            />
          </span>
          <textarea type="text" placeholder="Enter your message" required />
          <button>Submit</button>
        </form>
      </div>
      <div className="map">
        <iframe
          style={{ width: "100%", height: "400px" }}
          class="gmap_iframe"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=efa school dipapur&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        ></iframe>
      </div>
    </>
  );
};

export default Contact;
